import './index.styl';
import template from './index.jst';
import { User, TeamSnapshot } from '../../../models';
import Radio from 'backbone.radio';
import { View } from 'backbone.marionette';
import Cookie from "../../../../../core/utils/Storage/Cookie";

const COACH_CHANNEL = Radio.channel('coach');

export class TeamControls extends View {
	get className() {
		return 'team-builder-controls';
	}

	get template() {
		return template;
	}

	initialize() {
		this.liveScoresIntervalId = null;

		this.model = new TeamSnapshot({
			next_lockout: Date.now(),
			remaining_salary: '-',
			team_value: '-',
			is_list_view: false,
			is_coach_enabled: false,
			team_is_filled: false,
			is_mobile_view: true,
			is_unlimited_trades: false,
			team: {},
			scoreflow: {},
			is_active_round: false,
			team_is_began_to_score: false,
			is_somebody_playing: false,
			is_history_mode: false,
			history_round_id: null,
		});


		this.initListeners()
			.fetchData();

		return this;
	}

	async fetchData() {
		await this.model.fetch();
		return this;
	}

	ui() {
		return {
			radio_btns_toggle_layout: '.js-toggle-team-field',
			btn_auto_fill: '.js-autofill',
			btn_fantasy_coach: '.js-toggle-fantasy-coach',
			btn_save: '.js-save',
			btn_clear: '.js-clear',
			timer: '.js-team-field-next-lockout-timer',
			btn_coach: '.js-coach-locked'
		}
	}

	events() {
		return {
			'click @ui.btn_fantasy_coach': 'toggleFantasyStats',
			'click @ui.radio_btns_toggle_layout': 'toggleTeamView',
			'click @ui.btn_coach': 'showCoachPopup',
		}
	}

	triggers() {
		return {
			'click @ui.btn_auto_fill': 'team:autofill',
			'click @ui.btn_save': 'team:save',
			'click @ui.btn_clear': 'team:clear',
		}
	}

	onDomRefresh(){
		const update_timer_interval =  1000 * 30; // 30 Sec

		this.ui.timer.off();
		this.ui.timer.countdownDestroy();
		this.ui.timer.countdown({
			interval: update_timer_interval,
			show: {
				sec: false,
			}
		});

		this.ui.timer.on('complete', () => this.trigger('game:started'));

		return this;
	}

	init(args) {
		this.model.set(args);

		if(args.is_active_round && !args.is_history_mode){
			this.subscribeToLiveUpdates();
		}
		else {
			clearInterval(this.liveScoresIntervalId);
		}

		return this;
	}

	subscribeToLiveUpdates(){
		if(this.liveScoresIntervalId){
			return this;
		}

		const updateInterval = 1000 * 60 * 5;
		this.liveScoresIntervalId = setTimeout(() => this.model.fetch(), updateInterval);
	}

	initListeners(){
		this.listenTo(this.model, 'change', this.render);
		this.listenTo(this.model, 'change:scoreflow', this.calculateOverallScores);
		this.listenTo(this.model, 'change:team_score', this.calculateOverallScores);
		this.listenTo(this.model, 'change:history_round_id', this.calculateOverallScores);

		return this;
	}

	calculateOverallScores(){
		this.model.calculateOverallScores();

		return this;
	}

	highlightSaveBtn() {
		this.ui.btn_save.text('Saved');

		return this;
	}

	toggleTeamView(event){
		const is_list_view = event.target.value === 'list';

		this.model.set({ is_list_view });

		this.trigger('toggle:layout', { is_list_view });

		Cookie.set(`user-${User.id}-is_list_view`, is_list_view);

		return this;
	}

	toggleFantasyStats(event) {
		const is_coach_checked = event.target.checked;

		if (!User.has_assistant_coach && is_coach_checked) {
			COACH_CHANNEL.trigger('show:popup');
			event.target.checked = false;
			return this;
		}

		this.model.set({ is_coach_checked });

		this.trigger('toggle:fantasy:coach', is_coach_checked);

		return this;
	}

	showCoachPopup(){
		COACH_CHANNEL.trigger('show:popup');

		return this;
	}
}

export default TeamControls;